function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import CoveredOverlayModal from "./CoveredOverlayModal";
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { closeSecondLayerModal, openSecondLayerModal, stopSecondLayerModalListening } from "../../../redux/ui/modal/modalActions";
import { extractDecimalFrom } from "../../../helpers/stringUtils";
import { remToPx } from "../../../helpers/uiUtils";
import { setColor } from "../../../helpers/styleUtils";
const TriggerWrapper = styled.div`
  margin-bottom: .3rem;
`;
const StyledHeader = styled.div`
  background: none;
  text-align: center;
  padding: .3rem;
  min-height: 1.9rem;
`;
const StyledHR = styled.hr`
  margin: .3rem auto .6rem;
`;
const StyledCloseIcon = styled.div`
  position: absolute;
  top: .5rem;
  right: 1rem;
  transform: scale(0.8);

  &&:hover {
    cursor: pointer;
  }
`;

class UncoveredOverlayModal extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "state", {
      isOpen: false,
      modalStyle: {
        padding: '0.3rem 1rem 1rem 1rem',
        width: '16rem',
        top: '0',
        left: '0',
        visibility: 'visible',
        background: setColor.limedSpruce
      }
    });

    _defineProperty(this, "toggle", event => {
      const _this = this;

      if (!!event) {
        event.stopPropagation();
      }

      this.setState({
        modalStyle: { ...this.state.modalStyle,
          width: !!this.props.modalStyle ? this.props.modalStyle.width : this.state.modalStyle.width,
          visibility: 'hidden'
        }
      });
      const {
        top,
        left,
        height,
        right
      } = this.trigger.current.getBoundingClientRect();
      const modalBodyRef = this.childRef.current.modalBodyRef; // wait 25ms to let model html render, if it still has not rendered, set the default height to 160px

      setTimeout(() => {
        const {
          height: modalBodyHeight
        } = !!modalBodyRef.current ? modalBodyRef.current.getBoundingClientRect() : {
          height: 160
        };
        const modalWidth = !!_this.props.modalStyle && !!_this.props.modalStyle.width ? remToPx(extractDecimalFrom(_this.props.modalStyle.width)) : remToPx(extractDecimalFrom(_this.state.modalStyle.width));
        const modalHeight = !!_this.props.modalStyle && !!_this.props.modalStyle.height ? remToPx(extractDecimalFrom(_this.props.modalStyle.height)) : modalBodyHeight;
        const modalPosition1 = { ..._this.state.modalStyle,
          top: `${top + height + 10}px`,
          left: left + modalWidth > window.innerWidth ? `${window.innerWidth - modalWidth - 32}px` : `${left}px`,
          ..._this.props.modalStyle
        };
        const modalPosition2 = { ..._this.state.modalStyle,
          top: `${top - modalHeight - 30}px`,
          left: left + modalWidth > window.innerWidth ? `${window.innerWidth - modalWidth - 32}px` : `${left}px`,
          ..._this.props.modalStyle
        };
        const modalPosition3 = { ..._this.state.modalStyle,
          top: `${window.innerHeight - modalHeight - 30}px`,
          left: right + modalWidth > window.innerWidth ? `${left - modalWidth - 10}px` : `${right + 10}px`,
          ..._this.props.modalStyle
        };
        const modalStyle = top + modalHeight + 70 < window.innerHeight ? modalPosition1 : top - modalHeight - 30 > 0 ? modalPosition2 : modalPosition3;

        _this.setState({
          modalStyle: { ...modalStyle,
            visibility: 'visible'
          }
        });
      }, 25);
      this.setState(prevState => ({
        isOpen: !prevState.isOpen
      }), () => {
        if (this.state.isOpen) {
          this.props.openSecondLayerModal();
        } else {
          this.props.closeSecondLayerModal();
        }
      });
    });

    _defineProperty(this, "renderModal", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TriggerWrapper, {
        ref: this.trigger,
        onClick: this.toggle,
        style: this.props.triggerStyle
      }, this.props.trigger), /*#__PURE__*/React.createElement(CoveredOverlayModal, {
        isOpen: this.state.isOpen,
        toggle: this.toggle,
        modalStyle: this.state.modalStyle,
        className: 'uncovered-overlay-modal',
        ref: this.childRef,
        cypress: this.props.cypress
      }, /*#__PURE__*/React.createElement(StyledHeader, null, this.props.title), /*#__PURE__*/React.createElement(StyledCloseIcon, {
        onClick: this.toggle
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faTimes
      })), /*#__PURE__*/React.createElement(StyledHR, null), this.props.content));
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderModal());
    });

    this.trigger = /*#__PURE__*/React.createRef();
    this.childRef = /*#__PURE__*/React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.secondLayerListening && !this.props.secondLayer && this.state.isOpen) {
      this.props.stopSecondLayerModalListening();
      this.toggle();
    }
  }

}

function mapStateToProps(state) {
  return {
    secondLayer: state.ui.modal.secondLayer,
    secondLayerListening: state.ui.modal.secondLayerListening
  };
}

export default connect(mapStateToProps, {
  openSecondLayerModal,
  closeSecondLayerModal,
  stopSecondLayerModalListening
})(UncoveredOverlayModal);